import { Component, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { AuthService } from 'src/app/auth/auth.service';
import { ActivatedRoute, Router } from '@angular/router';
import { DashboardService } from '../dashboard/dashboard.service';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { DataService } from 'src/app/data-service/data.service';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-top-header',
  templateUrl: './top-header.component.html',
  styleUrls: ['./top-header.component.scss']
})
export class TopHeaderComponent implements OnInit {
  private ResponseVerifiedNormal$: Subject<any> = new Subject();
  role: any;
  name: any;
  roleName: string;
  login_id: string;
  public logo:any;
  public token: any;
  company_name: string;
  public login_Id = localStorage.login_id;
  isview: any;
  public id: any;
  epc_id: any;
  through: any;
  admin_id: any;
  SadminAccess: any = [];
  slave_admin_id: any;
  SadminAccess1 :any = [];
  // lastUpdatedAt:any = "";
  lastUpdatedAt$!: Observable<any>;

  constructor(private authService: AuthService,private dashboardService: DashboardService, private router: Router,
    private route: ActivatedRoute, private toastr: ToastrService,private dataService:DataService) {
    this.isview = localStorage.isview;
    this.role = localStorage.role;
    this.name = localStorage.name;
    this.epc_id = localStorage.epc_id;
    this.epc_id = localStorage.epc_id;
    this.admin_id = localStorage.admin_id;
    this.through = localStorage.through;
    this.slave_admin_id = localStorage.slave_admin_id;
    if(this.role == '1') {
      this.roleName = 'admin';
    } else if(this.role == '2') {
      this.roleName = 'epc';
    }
    else if(this.role == '3') {
      this.roleName = 'wms';
    }
    else if(this.role == '4') {
      this.roleName = 'normal';
    }
    else if(this.role == '4') {
      this.roleName = 'normal';
    }   else if(this.role == '5') {
      this.roleName = 'slave_admin';
    }
    else if(this.role == '6') {
      this.roleName = 'ze';
    }
    else if(this.role == '7') {
      this.roleName = 'dg';
    }
   }

  ngOnInit() {
     this.lastUpdatedAt$ = this.dataService.lastUpdatedAt;
   
  }
  openMessage() {
    this.toastr.success("Log Out Successfully");
    localStorage.clear();
  }

  viewPortalEpcUser() {
    var loginObj = {
      user_id: this.epc_id,
      isview: true
    };
    this.dashboardService.loginViewPortal(loginObj)
      .pipe(takeUntil(this.ResponseVerifiedNormal$))
      .subscribe(
        data => {
          if (data.status) {
            localStorage.clear();
            this.toastr.success(data.message);
            this.token = data.resultObject.token;
            this.role = data.resultObject.role;
            this.id = data.resultObject.id;
            this.name = data.resultObject.name;
            this.login_id = data.resultObject.login_id;
            this.logo = data.resultObject.logo;
            this.company_name =data.resultObject.company_name;
            this.SadminAccess = data.resultObject.SadminAccess ;
            // this.isview = data.isview;
            localStorage.setItem('loginToken', this.token);
            localStorage.setItem('role', this.role);
            localStorage.setItem('name', this.name);
            localStorage.setItem('id', this.id);
            localStorage.setItem('login_id', this.login_id);
            localStorage.setItem('logo', this.logo);
            localStorage.setItem('company_name', this.company_name);
             localStorage.setItem('SadminAccess', JSON.stringify(this.SadminAccess) || '[]');
            // localStorage.setItem('isview', this.isview);
            // this.router.navigate(['/inject-solar/dashboard/']);
            this.router.navigate(['/inject-solar/dashboard/'])
            .then(() => {
              window.location.reload();
            });
          } else if (!data.status) {
            if (data.message == 'Unauthorised or Login Time-out') {
              this.toastr.info(data.message);
              this.router.navigate(["/login"]);
            } else {
              this.toastr.info(data.message);
            }

          }
        },
        err => {
          return console.error(err);
        }
      );
  }
  viewPortalAdminUser() {
localStorage.removeItem("is_emeter");

    var loginObj = {
      user_id:  this.admin_id,
      isview: true
    };
    this.dashboardService.loginViewPortal(loginObj)
      .pipe(takeUntil(this.ResponseVerifiedNormal$))
      .subscribe(
        data => {
          if (data.status) {
            localStorage.clear();
            this.toastr.success(data.message);
            this.token = data.resultObject.token;
            this.role = data.resultObject.role;
            this.id = data.resultObject.id;
            this.name = data.resultObject.name;
            this.login_id = data.resultObject.login_id;
            this.logo = data.resultObject.logo;
            this.company_name =data.resultObject.company_name;
            this.SadminAccess = data.resultObject.SadminAccess ;
            // this.isview = data.isview;
            localStorage.setItem('loginToken', this.token);
            localStorage.setItem('role', this.role);
            localStorage.setItem('name', this.name);
            localStorage.setItem('id', this.id);
            localStorage.setItem('login_id', this.login_id);
            localStorage.setItem('logo', this.logo);
            localStorage.setItem('company_name', this.company_name);
            localStorage.setItem('SadminAccess', JSON.stringify(this.SadminAccess) || '[]');
            // localStorage.setItem('isview', this.isview);
            // this.router.navigate(['/inject-solar/dashboard/']);
            this.router.navigate(['/inject-solar/dashboard/'])
            .then(() => {
              window.location.reload();
            });
          } else if (!data.status) {
            if (data.message == 'Unauthorised or Login Time-out') {
              this.toastr.info(data.message);
              this.router.navigate(["/login"]);
            } else {
              this.toastr.info(data.message);
            }

          }
        },
        err => {
          return console.error(err);
        }
      );
  }
  viewPortalSlave_AdminUser() {
    var loginObj = {
      user_id:   this.slave_admin_id,
      isview: true
    };
    this.dashboardService.loginViewPortal(loginObj)
      .pipe(takeUntil(this.ResponseVerifiedNormal$))
      .subscribe(
        data => {
          if (data.status) {
            localStorage.clear();
            this.toastr.success(data.message);
            this.token = data.resultObject.token;
            this.role = data.resultObject.role;
            this.id = data.resultObject.id;
            this.name = data.resultObject.name;
            this.login_id = data.resultObject.login_id;
            this.logo = data.resultObject.logo;
            this.company_name =data.resultObject.company_name;
            this.SadminAccess = data.resultObject.SadminAccess ;
            // this.isview = data.isview;
            localStorage.setItem('loginToken', this.token);
            localStorage.setItem('role', this.role);
            localStorage.setItem('name', this.name);
            localStorage.setItem('id', this.id);
            localStorage.setItem('login_id', this.login_id);
            localStorage.setItem('logo', this.logo);
            localStorage.setItem('company_name', this.company_name);
            localStorage.setItem('SadminAccess', JSON.stringify(this.SadminAccess) || '[]');
            // localStorage.setItem('isview', this.isview);
            // this.router.navigate(['/inject-solar/dashboard/']);
            this.router.navigate(['/inject-solar/dashboard/'])
            .then(() => {
              window.location.reload();
            });
          } else if (!data.status) {
            if (data.message == 'Unauthorised or Login Time-out') {
              this.toastr.info(data.message);
              this.router.navigate(["/login"]);
            } else {
              this.toastr.info(data.message);
            }

          }
        },
        err => {
          return console.error(err);
        }
      );
  }
  ngOnDestroy() {

    this.ResponseVerifiedNormal$.next();
    this.ResponseVerifiedNormal$.complete();
  }

}
